import React, { useState } from "react";
import { SVGAsset } from "res/";
import "./styles.css";
import "./mobile.css";

/**
 * @function ConfirmBannerView
 * @param {React.Component} icon - React component of an icon that is shown in the banner.
 * @param {STRING} text - String to allow us to show the confirm text for different workflows.
 * @param {FUNCTION} onClick - Pass an onClick event that closes the banner.
 * @returns {React.Component}
 * @example
 * <PageLayoutContainer>
 *  <ConfirmBannerView text="Payment has been scheduled" icon={<SVGAsset id="CircleCheckmarkIcon" className="set-width icon checkmark-icon" />} />
 * </PageLayoutContainer>
 */
export default function ConfirmBannerView(props) {
  const closeIconDataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};
  const labelDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Label" } : {};
  const className = props.className ?? "";
  
  const [ state, setState ] = useState(true);
  const onClick = evt => {
    setState(false);

    if(props.onClick instanceof Function) {
      props.onClick();
    }
  };

  return (
    <>
      { state && 
        <div className={className + " confirm-banner-view flex-container flex-horizontal align-top"}>
          {props.icon}
          <div className="flex-width confirm-text" { ...labelDataPoint }>{props.text}</div>
          <SVGAsset id="CloseX" className="set-width icon dismiss-icon clickable" { ...closeIconDataPoint } onClick={ onClick } />
        </div>
      }
    </>
  );
}


/**
 * @function CheckmarkBanner
 * @param {STRING} text - String to allow us to show the confirm text for different workflows.
 * @param {FUNCTION} onClick - Pass an onClick event that closes the banner.
 * @returns {React.Component}
 * @example
 * <PageLayoutContainer>
 *  <CheckmarkBanner text="Payment has been scheduled" />
 * </PageLayoutContainer>
 */
export function CheckmarkBanner(props) {
  const text = props.text ?? "" ;
  const icon = <SVGAsset id="CircleCheckmarkIcon" className="set-width icon checkmark-icon" />;
  return (
    <ConfirmBannerView text={text} icon={icon} onClick={props.onClick} dataPoint={ props.dataPoint } />
  );
}

/**
 * @function InfoBanner
 * @param {STRING} text - String to allow us to show the confirm text for different workflows.
 * @param {FUNCTION} onClick - Pass an onClick event that closes the banner.
 * @returns {React.Component}
 * @example
 * <PageLayoutContainer>
 *  <InfoBanner text="Payment has been scheduled" />
 * </PageLayoutContainer>
 */
export function InfoBanner(props) {
  const text = props.text ?? "";
  const infoIconDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Info_Icon" } : {};
  const icon = <SVGAsset id="InfoIcon" className="set-width info-icon" { ...infoIconDataPoint } />;
  const className = props.className ?? "";
  return (
    <ConfirmBannerView className={className} text={text} icon={icon} onClick={props.onClick} dataPoint={ props.dataPoint } />
  );
}